import {
	Button,
	Checkbox,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Grid,
	Typography,
	CircularProgress
} from '@material-ui/core';
import GridItem from 'components/Grid/GridItem.jsx';
import React from 'react';
import { fields } from './objects';

class SelectFieldsDialog extends React.Component {
	onSubmit = () => {
		this.props.exportPDF();
	};

	render() {
		return (
			<Dialog
				open={this.props.open}
				onClose={this.props.closeDialog}
				className="selectFieldsDialog"
				style={{ maxWidth: '70%' }}
			>
				<DialogTitle id="form-dialog-title" style={{ textAlign: 'center' }}>
					Download Pdf
				</DialogTitle>
				<DialogContent style={{ paddingTop: '20px' }}>
					<div style={{ textAlign: 'center' }}>
						<Typography style={{ marginBottom: '15px' }}>
							Select fields which you would like to include
						</Typography>
					</div>
					<Grid container>
						{fields.map(field => {
							return (
								<GridItem
									xs={6}
									sm={4}
									md={3}
									key={field}
									style={{ display: 'flex', marginBottom: '10px' }}
								>
									<Typography
										style={{
											position: 'relative',
											top: '13px',
											maxWidth: '95px'
										}}
									>
										{field}
									</Typography>
									<Checkbox
										checked={this.props.selectedFields.includes(field)}
										onChange={this.props.handleFieldCheck(field)}
									/>
								</GridItem>
							);
						})}
					</Grid>
				</DialogContent>

				<DialogActions>
					<Button color="primary" onClick={this.props.closeDialog}>
						Cancel
					</Button>
					{this.props.savingPdf ? (
						<div>
							<CircularProgress
								color="secondary"
								size={20}
								style={{
									position: 'relative',
									left: '10px'
								}}
							/>
						</div>
					) : (
						<Button color="primary" onClick={this.onSubmit}>
							Download
						</Button>
					)}
				</DialogActions>
			</Dialog>
		);
	}
}
export default SelectFieldsDialog;



// WEBPACK FOOTER //
// ./src/views/Clients/components/advanced_search/SelectFieldsDialog.jsx